import { tv } from 'tailwind-variants';

const styles = tv({
  base: 'sr-only',
});

export default styles;
